export default __webpack_public_path__ + "static/media/pomex_base.bfcd71ec.png";